import { Get, Put, Delete } from "@/utils";
import { ApiPath } from "@/enums";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async removeNotification({ }, notificationId) {
      const { data: result } = await Delete(
        `${ApiPath.Notification}/removenotification/${notificationId}`
      );

      return result;
    },
    async removeSelectedNotifications({}, notificationIds) {
      const { data: result } = await Delete(
        `${ApiPath.Notification}/removeselectednotifications`,
        {
          data: { notificationId: notificationIds },
        }
      );

      return result;
    },
    async getNotificationsByUser({}, { userId, pageNumber, resultsPerPage }) {
      const { data: notifications } = await Get(
        `${ApiPath.Notification}/getnotificationsbyuser`,
        {
          userId,
          pageNumber,
          resultsPerPage
        }
      );
      notifications.results.forEach(element => {
        element.updated = new Date(element.updated).toLocaleString("en-US");
      });
      notifications.results = notifications.results.sort((a, b) => {
        return new Date(b.updated) - new Date(a.updated);
      });
      return notifications;
    },
    async readnotification({}, notifId) {
      const { data: notification } = await Put(
        `${ApiPath.Notification}/updatenotification`,
        {
          notificationId: notifId,
          isRead: true
        }
      );
      return notification;
    }
  }
};
